/**
 * Registers the service worker (production web only) and reports a waiting update so the shell can
 * show "New version available -- Reload". The worker never caches /api, /storage or any user file
 * (see public/sw.js BYPASS), so a stale worker can never serve stale data.
 */
export const SW_UPDATE_EVENT = 'bigroi:sw-update'
let waiting: ServiceWorker | null = null

export function registerServiceWorker(isNative: boolean) {
  if (!import.meta.env.PROD || isNative || !('serviceWorker' in navigator)) return
  window.addEventListener('load', () => {
    navigator.serviceWorker.register('/sw.js').then((reg) => {
      const announce = (w: ServiceWorker | null) => { if (w && navigator.serviceWorker.controller) { waiting = w; window.dispatchEvent(new Event(SW_UPDATE_EVENT)) } }
      announce(reg.waiting)
      reg.addEventListener('updatefound', () => {
        const w = reg.installing
        w?.addEventListener('statechange', () => { if (w.state === 'installed') announce(w) })
      })
      setInterval(() => { void reg.update().catch(() => {}) }, 30 * 60_000)
    }).catch((e) => console.warn('[sw] registration failed', e))
  })
  let reloading = false
  navigator.serviceWorker.addEventListener('controllerchange', () => { if (!reloading) { reloading = true; window.location.reload() } })
}

export function applyServiceWorkerUpdate() { waiting?.postMessage({ type: 'SKIP_WAITING' }) }
export function hasWaitingUpdate() { return !!waiting }
